const drawerWidth = 500;

// const useStyles = makeStyles((theme) => ({
export const styles = theme => ({
  breakpoints: {
    xs: 0, sm: 375, md: 768, lg: 1024, xl: 1920,
  },
  topDevice: {
    [theme.breakpoints.down('xs')]: {
      marginTop: '100px',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '78px',
    },
    [theme.breakpoints.up(1024)]: {
      marginTop: '100px',
      marginLeft: theme.spacing(8),
      marginRight: theme.spacing(8),
    },
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
      marginTop: '100px',
    },
  },
  layout: {
    justifyContent: 'space-around',
    width: 'auto',

    [theme.breakpoints.down('xs')]: {
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.up(1160 + theme.spacing(3) * 2)]: {
    // [theme.breakpoints.up(1160)]: {
      width: 1160,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  titleTH: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '2.5rem',
    fontWeight: 500,
    color: '#000',
    marginBottom: '-6px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2rem',
    },
  },
  titleTHMobile: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '1.2rem',
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  buttonNavbar: {
    fontFamily: theme.typography.fontKanit,
    fontSize: '0.9rem',
    fontWeight: 400,
  },
  buttonSelectProvinces: {
    color: 'white',
    fontFamily: theme.typography.fontKanit,
    fontSize: '20px !important',
    fontWeight: 500,
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      height: 23,
    },
  },
  // buttonMenu: {
  //   [theme.breakpoints.down('xs')]: {
  //     right: 20,
  //     zIndex: 3,
  //     position: 'absolute',
  //     display: 'flex',
  //   },
  // },
  buttonMenuMoblie: {
    [theme.breakpoints.down('sm')]: {
      right: 15,
      zIndex: 4,
      position: 'absolute',
      display: 'flex',
    },
    [theme.breakpoints.down('xs')]: {
      right: 5,
    },

  },
  icon: {
    color: 'white',
  },
  listSelectProvinces: {
    fontSize: '14px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px !important',
    },
  },
  root: {
    display: 'flex',
  },
  selectBox: {
    fontFamily: theme.typography.fontKanit,
    padding: theme.spacing(0.5),
    background: theme.palette.primary.main,
    borderRadius: '30px',
    textAlign: 'center',
    fontSize: '20px',
  },
  selectProvinces: {
    fontFamily: theme.typography.fontKanit,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: '30px',
    textAlign: 'center',
    fontSize: '20px',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      // marginLeft: theme.spacing(4),
      // marginRight: theme.spacing(4),
    },
  },
  dateTime: {
    color: 'white',
    fontSize: '20px',
    borderLeft: '1px solid #fff',
    align: 'center',
    [theme.breakpoints.down('sm')]: {
      borderLeft: 'none',
      fontSize: '13px',
    },
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  list: {
    width: 320,
  },
  fullList: {
    width: 'auto',
  },
  boxViewLeft: {
    left: 10,
    zIndex: 2,
    position: 'absolute',
    display: 'block',
  },
  boxViewRight: {
    right: 10,
    zIndex: 3,
    position: 'absolute',
  },
  lang: {
    fontFamily: 'Kanit',
    color: '#666',
  },
});